export const redirectToSingleResult = (
  objArray: any[],
  path: string,
  history: any,
  notification: (msg: string, timeout?: number) => void = () => {
    /* no-op default */
  }
) => {
  if (objArray.length === 1) {
    const objectId = objArray[0].originalUserId || objArray[0].id
    if (typeof notification === 'function') {
      notification('Found 1 result, sent directly to user page', 2000)
    }
    history.push({ pathname: `${path}/${objectId}` })
  }
}
